import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { AgencyClient } from "../types";

async function getClientsRequest(workspaceId: string): Promise<AgencyClient[]> {
  return (await get(`workspaces/${workspaceId}/clients`)).clients;
}

export default function useAgencyClients() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { agencyClientsKeys } = getQueryKeys(workspaceId);

  const {
    data: agencyClients,
    isLoading: isLoadingAgencyClients,
    isError: isAgencyClientsError,
    refetch: refetchAgencyClients,
  } = useQuery({
    queryKey: agencyClientsKeys.list,
    queryFn: () => getClientsRequest(workspaceId),
  });

  return {
    agencyClients,
    isLoadingAgencyClients,
    isAgencyClientsError,
    refetchAgencyClients,
  };
}
